import React from 'react';
import Icon from '../../../components/AppIcon';

const ImplementationMetrics = ({ actions }) => {
  const calculateMetrics = () => {
    const total = actions?.length;
    const completed = actions?.filter(a => a?.progress === 100)?.length;
    const inProgress = actions?.filter(a => a?.progress > 0 && a?.progress < 100)?.length;
    const notStarted = actions?.filter(a => a?.progress === 0)?.length;
    
    const totalBudget = actions?.reduce((sum, a) => sum + (a?.budget || 0), 0);
    const criticalActions = actions?.filter(a => a?.priority === 'critical')?.length;
    
    const avgProgress = total > 0 
      ? Math.round(actions?.reduce((sum, a) => sum + a?.progress, 0) / total)
      : 0;

    return {
      total,
      completed,
      inProgress,
      notStarted,
      totalBudget,
      criticalActions,
      avgProgress
    };
  };

  const metrics = calculateMetrics();

  const metricCards = [
    {
      icon: 'ListChecks',
      label: 'Total Aksi',
      value: metrics?.total,
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'CheckCircle2',
      label: 'Selesai',
      value: metrics?.completed,
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Clock',
      label: 'Dalam Progress',
      value: metrics?.inProgress,
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'Circle',
      label: 'Belum Dimulai',
      value: metrics?.notStarted,
      color: 'text-muted-foreground',
      bgColor: 'bg-muted'
    },
    {
      icon: 'DollarSign',
      label: 'Total Budget',
      value: `Rp ${(metrics?.totalBudget / 1000000)?.toFixed(1)}M`,
      color: 'text-accent-foreground',
      bgColor: 'bg-accent/10'
    },
    {
      icon: 'AlertTriangle',
      label: 'Aksi Kritis',
      value: metrics?.criticalActions,
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {metricCards?.map((metric, index) => (
          <div 
            key={index}
            className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-all duration-250"
          >
            <div className={`w-10 h-10 rounded-lg ${metric?.bgColor} flex items-center justify-center mb-3`}>
              <Icon name={metric?.icon} size={20} className={metric?.color} />
            </div>
            <p className="text-xs text-muted-foreground mb-1">{metric?.label}</p>
            <p className={`text-xl md:text-2xl font-bold ${metric?.color}`}>
              {metric?.value}
            </p>
          </div>
        ))}
      </div>
      <div className="bg-card rounded-xl border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-foreground">Progress Keseluruhan</h3>
          <span className="text-2xl font-bold text-primary">{metrics?.avgProgress}%</span>
        </div>
        <div className="w-full h-4 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-success transition-all duration-500"
            style={{ width: `${metrics?.avgProgress}%` }}
          />
        </div>
        <div className="flex justify-between mt-2 text-xs text-muted-foreground">
          <span>0%</span>
          <span>50%</span>
          <span>100%</span>
        </div>
      </div>
    </div>
  );
};

export default ImplementationMetrics;